import {FormControl, InputAdornment, InputLabel, OutlinedInput, styled} from '@mui/material'
import {FC, ReactNode, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {validateSpecialChar} from '../../../utils'
import * as bancas from '../redux/reducers'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import {reformatText} from '../../../utils/InputFormatCurrency'
import AccountCircle from '@mui/icons-material/AccountCircle'
import SaveAsIcon from '@mui/icons-material/SaveAs'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import HomeIcon from '@mui/icons-material/Home'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import GasMeterIcon from '@mui/icons-material/GasMeter'
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft'
import AlignHorizontalRightIcon from '@mui/icons-material/AlignHorizontalRight'
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom'
import PriceChangeIcon from '@mui/icons-material/PriceChange'
import CabinIcon from '@mui/icons-material/Cabin'
import EventNoteIcon from '@mui/icons-material/EventNote'
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle'
import DriveEtaIcon from '@mui/icons-material/DriveEta'
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import PaymentsIcon from '@mui/icons-material/Payments'

type Props = {
  children?: ReactNode
  label: string
  id: string
  inputClass?: string
  inputNumberOnly?: boolean
  maxLength?: number
  name: string
  placehoder: string
  objectSelected?: number
  inputReadonly?: boolean
  wrapperClass?: string
  inputValue?: string
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  showEndAdornment?: boolean
  formatCurrency?: boolean
  handleInputChange?: (value: string) => void
  handleBlurInput?: (value: string) => void
}

export const CustomInputBancas = styled(OutlinedInput)(({theme}) => ({
  borderRadius: '8px',
  '& .MuiInputBase-input': {
    padding: '13.5px 14px',
    fontWeight: '500',
  },
  '& .MuiInputAdornment-root': {
    marginRight: '0px',
  },
}))

export const InputBanCas: FC<Props> = ({
  children,
  label,
  id,
  inputNumberOnly,
  inputClass,
  maxLength,
  name,
  inputReadonly,
  objectSelected,
  inputValue,
  tabName,
  formName,
  required,
  validateField,
  handleInputChange,
  handleBlurInput,
  placehoder,
  formatCurrency,
  showEndAdornment,
}) => {
  const [value, setValue] = useState('')
  const dispatch = useDispatch()

  const handleChangeData = (event: any) => {
    if (!event.nativeEvent.data && !event.nativeEvent?.inputType) {
      handleSaveData(event)
    }
    if (inputNumberOnly) {
      const re = /^[0-9\b,.]+$/
      if (event.target.value === '' || re.test(event.target.value)) {
        setValue(event.target.value)
        if (handleInputChange) handleInputChange(event.target.value)
      }
    } else {
      let test = validateSpecialChar(event.target.value)
      if (
        !test &&
        !id.toLocaleLowerCase().includes('address') &&
        !id.toLocaleLowerCase().includes('name')
      )
        event.target.value = event.target.value.replaceAll(',', '')
      setValue(event.target.value)
      if (handleInputChange) handleInputChange(event.target.value)
    }
  }

  const handleSaveData = (event: any) => {
    if (event.type == 'blur') {
      let input = event.target.value.trim()
      if (handleBlurInput) handleBlurInput(input)
      if (formName && !formName.toLocaleLowerCase().includes('filter')) {
        let data = {
          key: id,
          value: input,
          tab: tabName ? tabName : '',
          form: formName,
          objectSelected: objectSelected ? objectSelected : 0,
        }
        dispatch(bancas.actions.addBancasInfors(data))
      } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
        let data = {
          field: id ? id : '',
          value: value,
          filterForm: formName,
        }
        dispatch(filter.actions.updateFilterInfo(data))
      }
    }
  }

  const IconInput = () => (
    <>
      {id == 'identificationNumber' && (
        <AssignmentIndIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'customerName' && <AccountCircle color='disabled' style={{opacity: '0.7'}} />}
      {id == 'addressName' && <HomeIcon color='disabled' style={{opacity: '0.7'}} />}
      {(id == 'mobile' || id == 'phone') && (
        <PhoneAndroidIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'email' && <AlternateEmailIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'certNumber' && <SaveAsIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'licensePlate' && (
        <AlignVerticalBottomIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'chassisNumber' && (
        <AlignHorizontalLeftIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'engineNumber' && (
        <AlignHorizontalRightIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'engineType' && <GasMeterIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'fuelType' && <LocalGasStationIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'floorNumber' && <CabinIcon color='disabled' style={{opacity: '0.7'}} />}
      {(id == 'yearBuilt' || id == 'manufacturingYear') && (
        <EventNoteIcon color='disabled' style={{opacity: '0.7'}} />
      )}
      {id == 'price' && <PriceChangeIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'driverNumber' && <DriveEtaIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'seat' && <AirportShuttleIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'payload' && <MonitorWeightIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'capacity' && <FilterAltIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'sumInsured' && <PaymentsIcon color='disabled' style={{opacity: '0.7'}} />}
      {id == 'creditContractNumber' && <EventNoteIcon color='disabled' style={{opacity: '0.7'}} />}
    </>
  )
  
  useEffect(() => {
    if (inputValue) setValue(inputValue)
    else setValue('')
  }, [inputValue])

  return (
    <div className='field-wrapper'>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <InputLabel id={label} htmlFor={id}>
          {label} {required && <span>*</span>}
        </InputLabel>
        <CustomInputBancas
          label={label}
          key={id}
          id={id}
          type='text'
          name={name}
          className={inputClass}
          placeholder={placehoder}
          value={value}
          onChange={(e) =>
            formatCurrency ? handleChangeData(reformatText(e)) : handleChangeData(e)
          }
          onBlur={(e) => {
            handleSaveData(e)
          }}
          inputProps={{maxLength: maxLength}}
          readOnly={inputReadonly}
          autoComplete='off'
          fullWidth
          error={validateField}
          startAdornment={
            <InputAdornment position='start'>
              <IconInput />
            </InputAdornment>
          }
          endAdornment={
            showEndAdornment && <InputAdornment position='end'>{children}</InputAdornment>
          }
        />
      </FormControl>
    </div>
  )
}
